








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import moment from "moment";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import {
  SuketBaseWithRelationship,
  SuketGadarContentInterface
} from "@/types/suket_gawat_darurat";
import StoreSuketGawatDarurat from "@/store/modules/SuketGawatDarurat";
import SuketGawatDarurat from "@/services/SuketGawatDarurat";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SuketGawatDaruratInputCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketGawatDaruratInputCard.vue";
import { storePasien } from "@/store/modules/pasien";
import BaseCardSuket from "@/components/pemeriksaan/resumeSuketV2/BaseCardSuket.vue";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    SuketGawatDaruratInputCard,
    BaseCardSuket
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class SuketGawatDaruratTabPage extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["01", "27", "06", "17"];
  modalTtd = false;
  instantCreate = false;

  get dataSuket(): SuketBaseWithRelationship<SuketGadarContentInterface> {
    return StoreSuketGawatDarurat.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketGawatDarurat.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataSuket?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_group_id);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketGawatDarurat.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.instantCreate = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    SuketGawatDarurat.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          StoreSuketGawatDarurat.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  createSuketInstantly() {
    this.expandInput = true;

    this.$nextTick(() => {
      this.instantCreate = true;
    });
  }

  removeSuket() {
    appModule.setLoading(true);

    SuketGawatDarurat.destroy(this.dataSuket?.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);

        StoreSuketGawatDarurat.getSuketByRegister(this.register);
      });
  }
}
